import { observer } from 'mobx-react-lite';

import { IcToggleDownIcon } from '@gem/icons';
import { FAB } from '@gem/ui-kit';

import { useScrollToBottomPresenter } from './ScrollToBottomButton.presenter';
import styles from './ScrollToBottomButton.styles.m.css';

export const ScrollToBottomButton = observer(({ lastMessage }) => {
  const presenter = useScrollToBottomPresenter(lastMessage);

  if (!presenter.hasScrollToBottomButton) {
    return null;
  }

  return (
    <FAB
      className={styles.button}
      size={'30'}
      onClick={presenter.moveToBottom}
      badge={presenter.badgeCount}
      Icon={IcToggleDownIcon}
    />
  );
});
